module.exports = __webpack_public_path__ + "img/symbol_2.7b3add86.png";